document.addEventListener('alpine:init', () => {
  Alpine.data('pmVideos', () => ({
    _activeTab: 0,
    get activeTab() {
      return this._activeTab;
    },
    set activeTab(index) {
      this._activeTab = index;
      this.initVideo(index).then(() => this.destroyInactiveVideos());
    },
    iframes: [],

    init() {
      this.$nextTick(() => {
        this.activeTab = 0;
      });
    },

    async initVideo(index) {
      const el = this.$root.querySelector(`[data-video-url][data-index="${index}"]`);
      el.innerHTML = await this.createVimeoEmbed(el.dataset.videoUrl);
    },

    destroyInactiveVideos() {
      this.$root.querySelectorAll('[data-video-url]').forEach((el) => {
        if (+el.dataset.index !== this.activeTab) {
          el.innerHTML = '';
        }
      });
    },

    async createVimeoEmbed(vimeoUrl) {
      const res = await fetch(`https://vimeo.com/api/oembed.json?url=${vimeoUrl}`).then((r) => r.json());
      return decodeURIComponent(res.html).replace(
        '<iframe',
        `<iframe class="block w-full h-auto" style="aspect-ratio: ${res.width} / ${res.height}"`
      );
    },
  }));
});